import { app } from '../../app';
import { Controller } from './info-sharing-center.controller';

app.component('infoSharingCenter', {
    controller: Controller,
    templateUrl: require('./info-sharing-center.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/info-sharing-center/info-sharing-center.component.js